import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const BrivityVaCard = () => {
  const isPlace = useIsPlace();
  const openLearnMore = () => {
    window.open(
      isPlace
        ? "https://brivityva.com?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-BVA-button"
        : "https://brivityva.com/?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=BP-BVA-button",
      "_blank",
    );
  };
  return (
    <ZoomCard
      actions={
        <>
          <Button
            size="medium"
            schema="secondary"
            className={`tw-flex tw-items-center tw-gap-[4px] ${isPlace ? "" : "hs-cta-trigger-button hs-cta-trigger-button-192021819570"}`}
            onClick={() => {
              if (isPlace) {
                window.open(
                  "https://share.hsforms.com/15wFiw_j8TuuQANoZdi9qtA3lhd2?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=interview-va&utm_content=PLACE-BVA-button",
                  "_blank",
                );
              }
            }}
          >
            Interview VA <ArrowUpRightFromSquareSolidV6 />
          </Button>

          <TextButton
            className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
            size="medium"
            onClick={openLearnMore}
          >
            Learn More <ArrowUpRightFromSquareSolidV6 />
          </TextButton>
        </>
      }
      onClick={openLearnMore}
      title="Brivity VA"
      description="Our virtual real estate assistants give you the time you deserve to focus on what you do best while keeping productivity up and costs down."
      imgSrc="/images/bg-card-brivity-va.png"
      imgClassName="tw-mr-[-12px]"
    />
  );
};

export default BrivityVaCard;
